import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function Bin(props: Props) {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.0001 6H3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5 9L5.8667 19.5556C5.8667 20.2778 6.57085 21 7.27501 21C7.97918 21 8.51359 21 10.8741 21H12.126C14.4865 21 15.0209 21 15.725 21C16.4291 21 17.1333 20.2778 17.1333 19.5556L18 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 6C6.05588 6 6.08382 6 6.10915 5.99936C6.93259 5.97849 7.65902 5.45491 7.93922 4.68032C7.94784 4.65649 7.95667 4.62999 7.97434 4.57697L8.07143 4.28571C8.15431 4.03708 8.19575 3.91276 8.25071 3.8072C8.47001 3.38607 8.87574 3.09364 9.34461 3.01877C9.46213 3 9.59317 3 9.85526 3H13.1447C13.4068 3 13.5379 3 13.6554 3.01877C14.1243 3.09364 14.53 3.38607 14.7493 3.8072C14.8043 3.91276 14.8457 4.03708 14.9286 4.28571L15.0257 4.57697C15.0433 4.62992 15.0522 4.65651 15.0608 4.68032C15.341 5.45491 16.0674 5.97849 16.8909 5.99936C16.9162 6 16.9441 6 17 6" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    </SvgIcon>
  );
}
